import {
  REDACTED,
  redactJsonField,
  redactPayloadField,
  SENSITIVE_URL_PARAM_PREFIXES,
  SENSITIVE_URL_PARAMS,
} from '../sensitiveFieldKeys';

/**
 * Returns the URL with any SENSITIVE_URL_PARAMS or SENSITIVE_URL_PARAM_PREFIXES
 * query values replaced by REDACTED. Matching is case-insensitive. Returns the
 * original string on parse failure.
 */
export function redactSensitiveUrlParams(raw: string): string;
export function redactSensitiveUrlParams(
  raw: string | undefined
): string | undefined;
export function redactSensitiveUrlParams(
  raw: string | undefined
): string | undefined {
  if (!raw) {
    return raw;
  }
  try {
    const url = new URL(raw);
    let changed = false;
    for (const key of url.searchParams.keys()) {
      const normalized = key.toLowerCase();
      if (
        SENSITIVE_URL_PARAMS.has(normalized) ||
        SENSITIVE_URL_PARAM_PREFIXES.some(prefix =>
          normalized.startsWith(prefix)
        )
      ) {
        url.searchParams.set(key, REDACTED);
        changed = true;
      }
    }
    return changed ? url.toString() : raw;
  } catch {
    return raw;
  }
}

/**
 * Scrubs sensitive fields from GraphQL resource events before they're sent to
 * Datadog. Redacts variables matching SENSITIVE_KEYS in graphql.variables,
 * graphql.payload, and context._dd.graphql.variables.
 */
export function redactGraphQlSensitiveFields(event: any) {
  const graphql = event.resource?.graphql;
  if (!graphql) {
    return;
  }

  graphql.variables = redactJsonField(graphql.variables);
  graphql.payload = redactPayloadField(graphql.payload);

  const ddKey = '_dd.graphql.variables';
  if (event.context?.[ddKey]) {
    event.context[ddKey] = redactJsonField(event.context[ddKey]);
  }
}
